import { endpoints } from 'services/endpoints';
import request from 'services/request';
import { paramsToFormData } from 'utils/utils';

export default {
  postScheduleList: (params: ProjectListReqDto): Promise<CommonListResDto> =>
    request({
      url: endpoints.operate.list,
      method: 'post',
      data: paramsToFormData(params),
    }),              
};
